import React, { useState, useEffect } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
//import SideBar from '../sidebar/sidebar'
import { Link } from 'react-router-dom';
import Axios from 'axios'
import ReactHtmlParser from 'react-html-parser'
import { BASE } from '../api/api';
import { withRouter } from 'react-router-dom'
import white from '../assets/search.png'
import makerlogo from '../assets/MM/MM Logo.png'
import maker1 from "../assets/MM/Dr Evren Tok.jpg"
import maker2 from "../assets/MM/Bayan Khaled.jpg"
import maker3 from "../assets/MM/Alina Zaman.jpg"
import house from "../assets/MM/house.png"
import pdf from "../assets/MM/pdf.png"
import mail from "../assets/MM/mail.png"
import user from "../assets/MM/user.png"
import report from "../assets/pubreport.pdf"
import music from "../assets/MM/musical-note.png"


class Sira extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            sira: [],
            menus: [],
            option: "Publication",
            option_show: false,
            keyword: '',
            searchfilter: '',
            details: null
        }
    }
    SideBar = () => {
        Axios.get(BASE + 'jsonapi/node/page?filter[field_front_end_sub_menu]=1&sort=field_sort')
            .then(resp => {
                this.setState({
                    menus: resp.data.data
                })
            })
        return (
            <div className='side-menu'>
                <div className='menu-item'>
                    {this.state.menus.map((data) => {
                        return <Link style={{ color: data.attributes.title == this.props.match.params.title ? '#000000' : '' }} to={`/specialised/${data.attributes.title}`}>{data.attributes.title}</Link>

                    })}
                </div>
            </div>
        )
    }
    componentDidMount() {
        this.apicall()
    }
    componentWillMount() {
        this.props.history.listen((location, action) => {
            console.log("action", action);
            window.location.reload(true)
            this.apicall()
        });
    }
    apicall() {
        const title = this.props.match.params.title
        var titl = title.replace(/&/g, `%26`);
        Axios.get(BASE + `jsonapi/node/page?filter[title]=${titl}`)
            .then((res) => {
                this.setState({
                    sira: res.data.data
                })
            })
        console.log('title', titl)
        console.log('specialised database page', this.state.sira)
    }
    fillalert(msg) {
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.search()
        }
    }
    search() {
        if (this.state.keyword.length < 3) {
            // alert("Enter atleast 3 characters")
            this.fillalert("Enter atleast 3 characters")

        }
        else
            // window.location.href = '/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20')
            this.props.history.push('/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20'))
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    render() {
        const links = [
            {
                "title": "Islam in a Global World",
                "link": "https://www.hbku.edu.qa/en/cis/maker-majlis/islam-global-world"
            },
            {
                "title": "DPCN",
                "link": "https://www.hbku.edu.qa/en/cis/maker-majlis/design-post-covid-normal-dpcn"
            },
            {
                "title": "COVID-19 Challenges",
                "link": "https://www.hbku.edu.qa/en/cis/maker-majlis/covid19-challenges"
            },
            {
                "title": "DPCH",
                "link": "https://www.maker-majlis.com/dpch"
            },
            {
                "title": "World Refugee Day",
                "link": "https://www.hbku.edu.qa/en/cis/maker-majlis"
            },
            {
                "title": "SCHIFA",
                "link": "https://www.hbku.edu.qa/en/cis/maker-majlis#menu-7"
            },
        ]
        const makers = [
            {
                "name": "Dr. M. Evren Tok",
                "bio": "Associate Professor of Islam and Global Affairs",
                "position": "",
                "mail": "https://www.hbku.edu.qa/en/cis/staff/mohamed-evren-tok",
                "img": maker1
            },
            {
                "name": "Bayan Khaled",
                "bio": "Organizer",
                "position": "Research Fellow",
                "mail": "https://ibir.hbku.edu.qa/faculty/bayan-khaled?nid=51313",
                "img": maker2
            },
            {
                "name": "Alina Zaman",
                "bio": "Organizer",
                "position": "Research Assistant",
                "mail": "",
                "img": maker3
            },
        ]
        return (
            <div>
                <Header />
                <div className='container specialised-page side-arrange' style={{ minHeight: '71.6vh' }}>
                    <this.SideBar />
                    {this.state.sira.length && this.props.match.params.title === "Maker Majlis" ?
                        <div className='columns maker-majlis'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to={`/specialised/${this.props.match.params.title}`}>{this.props.match.params.title}</Link></div>
                            <div className="page-title">
                                <div className="title-wrapper">
                                    <h1 className="heading">{this.state.sira.length ? this.state.sira[0].attributes ? this.state.sira[0].attributes.title : '' : ""}</h1>
                                </div>
                                <img className="maker-logo" src={makerlogo} />
                            </div>
                            <div className="main-content listing">
                                <div id="newpad2233" className="">
                                    <div className="row">
                                        <div className="region region-content">
                                            <div className="listings">
                                                {this.state.sira.length ? this.state.sira[0].attributes ? this.state.sira[0].attributes.body ? ReactHtmlParser(this.state.sira[0].attributes.body.value) : '' : "" : ''}
                                            </div>
                                            <p className="maker-links-head">Below are some of the major events under the umbrella of Maker Majlis.</p>
                                            <table className="link-table">
                                                <tr>
                                                    <td><a href="https://www.maker-majlis.com/" className="img" target="_blank"> <img src={house} /> </a></td>
                                                    {links.map(data => {
                                                        return (
                                                            <td className="table-links"><a href={data.link} className="links" target="_blank">
                                                                {data.title}
                                                            </a>
                                                            </td>
                                                        )
                                                    })}
                                                </tr>
                                            </table>
                                            <p className="makers-head">Meet the Makers</p>
                                            <div className="rows maker-makers">
                                                {makers.map((data, ind) => {
                                                    return (
                                                        <div className="single-maker rows">
                                                            <img className="image" src={data.img} />
                                                            <div className="maker-details">
                                                                {data.mail ? <a className="maker-name" target="_blank" href={data.mail} >{data.name}</a> : <div className="maker-name" >{data.name}</div>}
                                                                <p className="maker-bio">{data.bio}</p>
                                                                <p className="maker-position">{data.position}</p>
                                                                {/* <div className="rows makers-mc">
                                                                    <img src={user} />
                                                                    <img src={mail} />
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div className="rows click-here">To read the report of the latest event, click here  <a target='_blank' href={report}> <img src={pdf} /></a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='columns'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to={`/specialised/${this.props.match.params.title}`}>{this.props.match.params.title}</Link></div>
                            <div className="page-title">
                                <div className="title-wrapper">
                                    <div className="">
                                        <h1 className="heading">{this.state.sira.length ? this.state.sira[0].attributes ? this.state.sira[0].attributes.title : '' : ""}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="main-content listing">
                                <div id="newpad2233" className="">
                                    <div className="row">
                                        <div className="region region-content">
                                            <div className="listings text-justify">
                                                {this.state.sira.length ? this.state.sira[0].attributes ? this.state.sira[0].attributes.body ? ReactHtmlParser(this.state.sira[0].attributes.body.value) : '' : "" : ''}
                                            </div>
                                        </div>
                                        {this.state.sira.length && this.props.match.params.title == 'Islamic Economics & Finance' ? <div className="newsearchdiv">
                                            <input type="text" placeholder="Explore IEF Database" name="keyword" value={this.state.keyword} size="40" minLength="3" maxLength={120} onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} style={{ borderRight: 'none' }} />
                                            <div className="newsearchicon">
                                                <img onClick={() => this.search()} src={white} alt='white' />
                                            </div>
                                        </div>
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <Footer />
            </div>
        )
    }
}
export default withRouter(Sira);